import React, {Component} from 'react';
import EpicMenu from '../Menus/EpicMenu';
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
//import 'firebase/storage';
import Empleado from './Empleado';
import NuevoEmpleado from './nuevoEmpleado';
import Single from '../../componentes/Single'
import { Dropdown, Modal, Icon, Label, LabelDetail } from 'semantic-ui-react'
import { Loader,Dimmer } from 'semantic-ui-react'
import {withRouter} from 'react-router-dom'
import { AuthContext } from '../../Auth'
import {getCompanyCollection, getCompanyDocument} from '../../firebase'

class PaginaEmpleados extends Component{
	static contextType = AuthContext

	constructor(props){
		super(props);
		this.app= firebase;
		this.database = null;
		//this.storage = this.app.storage().ref();
		this.state = {
			empMax: 1,
			activeEmployeeCount: 0,
			demo: false,
			loaded: false,
			status: "todos",
			empleados: [],
		}
	}

	async componentDidMount(){
		this.database = await getCompanyCollection('Empleados')
		this.getData()
		this.activeEmployeesUnsubscribe = this.database.where('activo', '==', 'si').onSnapshot(snap => {
			this.setState({activeEmployeeCount: snap.size})
		})
		this.getEmp()
	}
	componentWillUnmount(){
		if (this.employeesUnsubscribe) this.employeesUnsubscribe()
		if (this.activeEmployeesUnsubscribe) this.activeEmployeesUnsubscribe()
	}
	componentDidUpdate(prevProps, prevState){
        let filtersHaveChanged=false
        if(this.state.status!==prevState.status)
            filtersHaveChanged=true
        if(filtersHaveChanged){
            this.getData()
        }
    }
	filtro =()=>{
		let dbReference=this.database
        if(this.state.status==='activos')
            return dbReference.where('activo', '==', 'si')
        if(this.state.status==='no')
            return dbReference.where('activo', '==', 'no')
        return dbReference
    }

	handleStatusChange=(e, {value})=>{
        this.setState({status: value})
    }
	navigateToSubscriptions = () => {
		this.props.history.push('/ajustes')
	}
	getEmp = async() =>{
		try {
			const docRef = await getCompanyDocument();
			const doc = await docRef.get();
			if (doc.exists) {
				const empAnual = Number(doc.data().empAnual) || 0
				const empMensual = Number(doc.data().empMensual) || 0
				// El primer empleado está incluido sin costo; los planes se cobran
				// únicamente por los empleados adicionales.
				let empMax = 1 + empAnual + empMensual
				if (doc.data().demo){
					empMax = 5
				} 
				this.setState({empMax: empMax})
			} else {
			  console.log('Document not found');
			}
		  } catch (error) {
			console.error('Error fetching document:', error);
		}
	}
	getData = () => { 
		if (this.employeesUnsubscribe) this.employeesUnsubscribe()
		this.setState({loaded: false})
		this.employeesUnsubscribe = this.filtro().orderBy('Nombre').onSnapshot( async snap =>{
			const empleados = [] 
			for(let i=0; i<snap.docs.length; i++){
				const doc=snap.docs[i]
				try{
				
				//const url=await this.storage.child(`images/profile-pics/${doc.data().foto}.jpg`).getDownloadURL()
				empleados.push({
					id: doc.id,
					nombre: doc.data().Nombre,
					correo: doc.data().Correo,
					rol: doc.data().rol,
					foto: doc.data().foto,
					imss: doc.data().IMSS,
					nacimiento: doc.data().Nacimiento,
					telefono: doc.data().telefono,
					sueldos: doc.data().sueldos,
					activo: doc.data().activo,
					uid: doc.data().uid,
					//url: url,
				}) } catch(error){
					console.log(error)
				}	
			}
			this.setState({
				empleados: empleados,
				loaded: true,
			})
		})
	
	}

	guardarDatos=async (datos)=>{
		if (datos.activo === 'si') {
			const activos = await this.database.where('activo', '==', 'si').get()
			const otrosActivos = activos.docs.filter(doc => doc.id !== datos.id).length
			if (otrosActivos >= this.state.empMax) {
				alert(`Ya alcanzó el máximo de ${this.state.empMax} empleados activos.`)
				return false
			}
		}
		const data=this.database.doc(datos.id)
		await data.update({
			Correo: datos.correo, 
			activo: datos.activo,
			telefono: datos.telefono,
			rol: datos.rol,
			sueldos: datos.sueldos
		})
		return true
    }

	newRegistro = async (empleado) =>{
		this.database.add({
			Nombre: empleado.nombre,
			rol: empleado.rol,
			imss: empleado.imss,
			Nacimiento: empleado.nacimiento,
			telefono: empleado.telefono,
			Correo: empleado.mail,
			activo: empleado.activo,
		})
		.then(()=>{
			console.log('Registro Exitoso')
		})
		.catch(e=>{
			alert(e)
		})
	}

	modalAgregar = () => (
		<Modal 
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo Empleado</button>}>
			<Modal.Header>
					<div>Registrar Empleado</div>
			</Modal.Header>
			<Modal.Content>
				<NuevoEmpleado empMax={this.state.empMax} onCancel={() => this.changeUsModal(false)} />
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}

	render(){
		return (
		<div>
			<div className='header'>
				<EpicMenu />
				<div className='inline'>Empleados</div>
				<div className="addNew" ><this.modalAgregar /></div>
			</div>
			<div className='contentLeft'>
				<Single 
					tabla='Empleados' 
					columna='Nombre'
					placeholder='Empleados'
					incluir={["Todos"]}
					value={this.state.employee} 
					onChange={this.handleEmployeeChange} 
					all={1} 
				/>
				<Dropdown
					selection
					compact
					options={[
						{key:1, value:'todos', text:'Todos'},
						{key:2, value:'activos', text:'Activos'},
						{key:3, value:'no', text:'Inactivos'}
					]}
					value={this.state.status}
					placeholder='Todos'
					onChange={this.handleStatusChange}
				/>
				<Label>
					Máximo de empleados activos:
					<LabelDetail>
						{this.state.empMax}
					</LabelDetail>
				</Label>
				<button type='button' className='increaseEmployeeLimit' onClick={this.navigateToSubscriptions}>Aumentar</button>
			</div>
			<div className='body'>
			<div className="tabla">
			<Dimmer active={!this.state.loaded}>
				<Loader className="loader" >Cargando...</Loader>
			</Dimmer>
				<table><tbody>
					<tr>
						{/*<th>Foto</th>*/}
						<th>Nombre</th>
						<th>Correo</th>
						<th>Rol</th>
						<th>Activo</th>
						<th>Sueldos</th>
					</tr>
					{
						this.state.empleados.map((empleado) => {
							return (
								<tr key={empleado.id} ><Empleado  
								nombre={empleado.nombre}
								correo={empleado.correo}
								rol={empleado.rol}
								foto={empleado.foto}
								imss={empleado.imss}
								sueldos={empleado.sueldos}
								url={empleado.url}
								currentUser={this.context.currentUser}
								id={empleado.id}
								activo={empleado.activo}
								uid={empleado.uid}
								empMax={this.state.empMax}
								activeEmployeeCount={this.state.activeEmployeeCount}
								guardarDatos={this.guardarDatos}
								/></tr>
								)
							})
						}
				</tbody></table>
			</div>
			</div> 
			<div className="footer" >
                <div className="footer1" ></div>
                <div className="footer2" ></div>
			</div>
		</div>
		);
	}
}

export default withRouter(PaginaEmpleados);
